import { ButtonPrimary, StepIndicator, typographyRem } from '@by-miles/bymiles-styles'
import React, { useContext, useEffect, useState } from 'react'

import { quoteId } from '../cache'
import { AccessibleFormWrapper } from '../components/AccessibleFormWrapper'
import LoadingMask from '../components/LoadingMask'
import CarHistory from '../components/QuoteFlow/Car/CarHistory/CarHistory'
import { CarMileageContainer } from '../components/QuoteFlow/Car/CarMileage/CarMileageContainer/CarMileageContainer'
import { CarModifications } from '../components/QuoteFlow/Car/CarModifications'
import { EnterRegistrationContainer } from '../components/QuoteFlow/Car/EnterRegistration/EnterRegistrationContainer'
import { BasePage } from '../HOCs/BasePage'
import { ProviderContext } from '../Provider'
import { quoteSteps } from '../utils/steps'
import { useCarPageContext } from './CarPageProvider'
import { EntryStepsStyles } from './styles/EntryStepsStyles'
const { hero: Hero } = typographyRem

const Car = () => {
  const id = quoteId() || ''
  const {
    simpleStateUpdater,
    state: { isFetching },
  } = useContext(ProviderContext)
  const { validateAndSave } = useCarPageContext()

  const [showRegInput, setShowRegInput] = useState<boolean>(!id)

  useEffect(() => {
    if (window.zE) {
      window.zE('webWidget', 'show')
    }
  }, [])

  // * Used to update screen height through re-render for footer positioning
  // * ToDo Find a way to trigger a re-render in the footer component without a full re-render
  useEffect(() => {
    simpleStateUpdater([{ state: 'showRegInput', value: showRegInput }])
  }, [showRegInput])

  return (
    <EntryStepsStyles>
      {isFetching && <LoadingMask />}
      <div className="car-wrapper">
        <StepIndicator validateOnClick={validateAndSave} steps={quoteSteps} preFilledStep="car" />
        <Hero>Tell us about your car.</Hero>
        <EnterRegistrationContainer showRegInput={showRegInput} setShowRegInput={setShowRegInput} />
        {!showRegInput && (
          <div className="entry-step-component-wrapper">
            <AccessibleFormWrapper onSubmit={validateAndSave}>
              <CarModifications />
              <CarHistory />
              <CarMileageContainer />
              <ButtonPrimary
                type="submit"
                label="Continue / Driver"
                iconRight="IconArrowRight"
                shadow
                dataCy="continue-driver-button"
                className="continue-button"
              />
            </AccessibleFormWrapper>
          </div>
        )}
      </div>
    </EntryStepsStyles>
  )
}

export default BasePage(Car)
